var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocataireRecto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 552 555.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#12171c;}.cls-1,.cls-5{stroke:#12171c;}.cls-1,.cls-3,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-2,.cls-3,.cls-6{fill:#fff;}.cls-3,.cls-6{stroke:#33163a;}.cls-4{fill:#dbf226;}.cls-5{fill:none;stroke-width:2px;}.cls-6{opacity:0.82;}.cls-7{fill:#052941;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Locataire recto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_7",
    "data-name": "Calque 7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 10,
    width: 550,
    height: 545,
    rx: 24.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 1,
    width: 550,
    height: 545,
    rx: 24.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.18,
    y: 17.54,
    width: 499.77,
    height: 452.46,
    rx: 28.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M657,1001c252.5,116.5,496-192,330-419.5l195,.5c17,1,29,11,25,34V850s-6.52,189-218.26,276.5C812,1126,682,1127,682,1127c-12,0-26-10-24-33Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1.5,
    y: 1,
    width: 549.5,
    height: 545,
    rx: 24.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 26.18,
    y: 17.54,
    width: 499.77,
    height: 452.46,
    rx: 28.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M873.39,1098v-20.58h2.89V1098Zm1.44,0v-2.74h11.79V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M895.37,1098.22a5.87,5.87,0,0,1-4.48-1.68,6.63,6.63,0,0,1-1.58-4.72v-2.4a6.5,6.5,0,0,1,1.58-4.67,6.86,6.86,0,0,1,9,0,6.46,6.46,0,0,1,1.59,4.67v2.44a6.51,6.51,0,0,1-1.59,4.69A5.89,5.89,0,0,1,895.37,1098.22Zm0-2.75a2.94,2.94,0,0,0,2.34-1,3.92,3.92,0,0,0,.83-2.66v-2.44a3.85,3.85,0,0,0-.83-2.64,3.38,3.38,0,0,0-4.68,0,3.8,3.8,0,0,0-.83,2.64v2.44a3.87,3.87,0,0,0,.83,2.66A3,3,0,0,0,895.37,1095.47Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M911.47,1098.22a5.81,5.81,0,0,1-6.36-6.39v-2.42a6.29,6.29,0,0,1,1.66-4.67,6.39,6.39,0,0,1,4.7-1.65,7.74,7.74,0,0,1,3.11.61,5.34,5.34,0,0,1,2.21,1.74l-2.08,1.87a4.36,4.36,0,0,0-1.44-1.09,4.29,4.29,0,0,0-1.76-.38,3.45,3.45,0,0,0-2.59.94,3.56,3.56,0,0,0-.92,2.63v2.42a3.68,3.68,0,0,0,.92,2.69,3.45,3.45,0,0,0,2.59,1,4,4,0,0,0,1.76-.41,4.32,4.32,0,0,0,1.44-1.16l2.08,2a5.34,5.34,0,0,1-2.21,1.7A7.64,7.64,0,0,1,911.47,1098.22Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M924.68,1098.22a6.3,6.3,0,0,1-4.06-1.12,4.21,4.21,0,0,1-1.35-3.43,4.13,4.13,0,0,1,1.24-3.28,5.51,5.51,0,0,1,3.72-1.08h4.17l.2,2.32h-4.36a2.51,2.51,0,0,0-1.69.5,2,2,0,0,0-.56,1.54,1.9,1.9,0,0,0,.75,1.66,3.85,3.85,0,0,0,2.25.54,6.37,6.37,0,0,0,2.46-.36,1.16,1.16,0,0,0,.83-1.1l.29,2.06a3.18,3.18,0,0,1-1,1,4.1,4.1,0,0,1-1.29.58A6.93,6.93,0,0,1,924.68,1098.22Zm3.6-.22v-9.31a3.09,3.09,0,0,0-.78-2.25,2.89,2.89,0,0,0-2.18-.8,5.86,5.86,0,0,0-1.71.26,5.23,5.23,0,0,0-1.51.76l-2.11-1.44a5.62,5.62,0,0,1,2.2-1.57,8,8,0,0,1,3-.56,6,6,0,0,1,4.28,1.43,5.29,5.29,0,0,1,1.51,4V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M934.28,1085.91v-2.6h6.63v2.6Zm5,12.16a3.19,3.19,0,0,1-2.63-1,4.5,4.5,0,0,1-.82-2.89V1079h2.89v15.18a1.33,1.33,0,0,0,.22.82.7.7,0,0,0,.62.3h1.39v2.74Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M949.57,1098.22a6.27,6.27,0,0,1-4.05-1.12,5,5,0,0,1-.12-6.71,5.54,5.54,0,0,1,3.72-1.08h4.18l.19,2.32h-4.36a2.5,2.5,0,0,0-1.68.5,2,2,0,0,0-.57,1.54,1.9,1.9,0,0,0,.75,1.66,3.85,3.85,0,0,0,2.25.54,6.46,6.46,0,0,0,2.47-.36,1.15,1.15,0,0,0,.82-1.1l.3,2.06a3.29,3.29,0,0,1-1,1,4.16,4.16,0,0,1-1.3.58A6.8,6.8,0,0,1,949.57,1098.22Zm3.6-.22v-9.31a3.13,3.13,0,0,0-.77-2.25,2.93,2.93,0,0,0-2.19-.8,5.86,5.86,0,0,0-1.71.26,5,5,0,0,0-1.5.76l-2.11-1.44a5.55,5.55,0,0,1,2.2-1.57,8,8,0,0,1,3-.56,6,6,0,0,1,4.28,1.43,5.3,5.3,0,0,1,1.52,4V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M960.31,1080.3v-2.88h2.88v2.88Zm0,17.7v-14.69h2.88V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M967.58,1098v-14.69h2.89V1098Zm8.09-11.21a2.51,2.51,0,0,0-1-.71,3.54,3.54,0,0,0-1.35-.24,2.88,2.88,0,0,0-2.13.76,2.84,2.84,0,0,0-.76,2.1l-.29-2.83a5.3,5.3,0,0,1,1.74-2,4.19,4.19,0,0,1,2.39-.74,5.47,5.47,0,0,1,1.82.29,4.1,4.1,0,0,1,1.42.86Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M985.69,1098.22a6.33,6.33,0,0,1-4.75-1.72,6.62,6.62,0,0,1-1.69-4.87V1090a7.34,7.34,0,0,1,1.62-5.08,5.84,5.84,0,0,1,4.57-1.8,5.06,5.06,0,0,1,4.3,2,9.44,9.44,0,0,1,1.52,5.72v1h-9.91v-2.33h7.16a4.87,4.87,0,0,0-.93-2.79,2.58,2.58,0,0,0-2.14-1,3.11,3.11,0,0,0-2.53,1.08,4.54,4.54,0,0,0-.91,3v1.87a3.78,3.78,0,0,0,1,2.8,3.67,3.67,0,0,0,2.72,1,4.71,4.71,0,0,0,1.75-.35,5,5,0,0,0,1.54-1l1.9,1.9a8,8,0,0,1-2.45,1.62A6.89,6.89,0,0,1,985.69,1098.22Z",
    transform: "translate(-656 -580.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocataireRecto);
export default __webpack_public_path__ + "static/media/locataire_recto.d2a8884a47405edf250216dc57e5eb35.svg";
export { ForwardRef as ReactComponent };